import { render } from "./Events_1.vue?vue&type=template&id=52f4379a&ts=true"
import script from "./Events_1.vue?vue&type=script&lang=ts"
export * from "./Events_1.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__